<style>
.tch-info-modal .ivu-modal-wrap {
  z-index: 2000;
}
</style>
<template>
  <div>
    <Modal title="约试听课" v-model="visible" width="600" :mask-closable="false" v-drag-modal>
      <Form ref="trialLessonForm" class="form"
            :model="trialLessonParam" :rules="ruleTrialLesson"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="学生信息">
              <label>{{ trialLessonParam.uid }} - {{ trialLessonParam.mobile }} - {{
                  trialLessonParam.nickname
                }}</label>
            </Form-item>
          </Col>
          <Col :span="12">
            <Form-item label="开始Level" prop="levelId">
              <Select filterable v-model.number="trialLessonParam.levelId" placeholder="请选择等级，支持搜索"
                      @on-change="changeLevel" transfer>
                <Option v-for="item in bookMaterialLevelList"
                        :value="item.id" :key="item.id">{{ item.title }}(版本{{ item.materialVersion }})
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="10">
            <Form-item label="教室" prop="schoolId">
              <Select v-model.number="trialLessonParam.schoolId" transfer>
                <Option v-for="item in $constant.schoolEnums"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="开始课程" prop="lessonId">
              <Select v-model.number="trialLessonParam.lessonId" transfer>
                <Option v-for="item in bookMaterialLessonsList"
                        :value="item.id" :key="item.id">{{ item.title }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="开始时间" prop="lsnBeginDayTime">
              <Row :gutter="6">
                <Col span="7">
                  <Form-item>
                    <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                                 @on-change="lsnBeginTimeDateChange" :clearable="false"
                                 v-model="trialLessonParam.lsnBeginTimeDate"></Date-picker>
                  </Form-item>
                </Col>
                <Col span="5">
                  <Form-item>
                    <Time-picker :key="timePickerKey" @on-change="onChangeTime" :clearable="false" v-model="timeStr"
                                 format="HH:mm" :steps="[1, 30]" placeholder="时间"></Time-picker>
                  </Form-item>
                </Col>
                <Col span="4">
                  <Form-item>
                    <Select v-model.number="trialLessonParam.timeLength" transfer>
                      <Option v-for="item in timeLengthList"
                              :value="item.code" :key="item.code">{{ item.text }}
                      </Option>
                    </Select>
                  </Form-item>
                </Col>
                <Col span="5" offset="1">
                  <Button type="info" @click="searchTch" :loading="loadingSearch">搜索</Button>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="空课老师">
              <TeacherSelect :category="[1,2,3]" :isAudition="y" v-model="tId" :label="tchName"
                             @on-change="onTchChange"></TeacherSelect>
            </Form-item>
            <Form-item label="适宜级别">
              <RadioGroup v-model="trialLessonParam.suitableLevel">
                <Radio label=""><span>全部</span></Radio>
                <Radio label="1"><span>Level1</span></Radio>
                <Radio label="5"><span>Level2</span></Radio>
                <Radio label="2"><span>Level3-Level5</span></Radio>
                <Radio label="3"><span>Level6-Level9</span></Radio>
                <Radio label="4"><span>Wonders及其他</span></Radio>
                <Radio label="6"><span>PU</span></Radio>
              </RadioGroup>
            </Form-item>
            <Form-item prop="tchId">
              <Form-item prop="category">
                <RadioGroup v-model="trialLessonParam.category">
                  <Radio label="">
                    <span>全部</span>
                  </Radio>
                  <Radio label="1">
                    <span>全职老师</span>
                  </Radio>
                  <Radio label="2">
                    <span>兼职老师</span>
                  </Radio>
                </RadioGroup>
                <RadioGroup v-model="trialLessonParam.channel">
                  <Radio label="">
                    <span>全部</span>
                  </Radio>
                  <Radio label="1">
                    <span>欧美</span>
                  </Radio>
                  <Radio label="2">
                    <span>菲教</span>
                  </Radio>
                </RadioGroup>
                <RadioGroup v-model="trialLessonParam.accent">
                  <Radio label="">
                    <span>全部</span>
                  </Radio>
                  <Radio label="1">
                    <span>英音</span>
                  </Radio>
                  <Radio label="2">
                    <span>美音</span>
                  </Radio>
                </RadioGroup>
                <RadioGroup v-model="trialLessonParam.sex">
                  <Radio label="">
                    <span>全部</span>
                  </Radio>
                  <Radio label="1">
                    <span>男</span>
                  </Radio>
                  <Radio label="2">
                    <span>女</span>
                  </Radio>
                </RadioGroup>
              </Form-item>
              <Row>
                <Radio-group v-model.number="trialLessonParam.tchId">
                  <Row>
                    <Col v-for="item in tchList" style="width: 140px;" :span="10">
                      <Radio :key="item.id" :label="item.id">{{ item.id }} - {{ item.firstName }} {{
                          item.lastName
                        }}
                      </Radio>
                      <a @click="showTchMessage(item.id)"><img
                        :src="tchAvatarSrc(item.avatar)" style="width: 120px;height: 120px"></a>
                    </Col>
                  </Row>
                </Radio-group>
              </Row>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingConfirm" @click="insertTrialLesson">确定</Button>
      </div>
    </Modal>
    <tch-info-modal class="tch-info-modal" :canEdit="false" :value="showTchInfoModal" @on-close="showTchInfoModal=false"
                    :tchId="tchId" :successCallback="updateTchInfoSuccess"></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from '../teacher/modal/TchInfoModal'
import commonUtils from '@/tools/commonUtils.js'

export default {
  components: {TchInfoModal},
  name: 'UserTrialLessonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let self = this
    return {
      visible: this.value,
      loadingConfirm: false,
      loadingSearch: false,
      classTypeList: [{code: 1, text: 'ClassIn'}],
      timeLengthList: [{code: 25, text: '25'}],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      trialLessonParam: {
        uid: null,
        tchId: '',
        category: '',
        channel: '1',
        accent: '',
        sex: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        lsnType: 1,
        schoolId: 0,
      },
      timeStr: '',
      timePickerKey: 0,
      ruleTrialLesson: {
        levelId: [
          {type: 'integer', required: true, message: '请选择开始Level', trigger: 'change'}
        ],
        lessonId: [
          {type: 'integer', required: true, message: '请选择开始课程', trigger: 'change'}
        ],
        classType: [
          {type: 'integer', required: true, message: '请选择教室', trigger: 'change'}
        ],
        tchId: [
          {type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change'}
        ],
        lsnBeginDayTime: [
          {type: 'integer', required: true, message: '请选择日期', trigger: 'change'},
          {
            validator (rule, value, callback, source, options) {
              let errors = []
              if (self.trialLessonParam.time === '') {
                errors.push('请选择时间')
                callback(errors)
                return
              }
              let lsnBeginTime = self.getLsnBeginTime()
              let nowTime = new Date().getTime() / 1000
              if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              callback()
            }
          }
        ]
      },
      tchId: null,
      showTchInfoModal: false,
      tId: '',
      tchName: ''
    }
  },
  methods: {
    tchAvatarSrc (avatar) {
      return commonUtils.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
    },
    secondsFromPicker () {
      const val = this.timeStr
      if (val instanceof Date && !isNaN(val.getTime())) {
        return val.getHours() * 3600 + val.getMinutes() * 60
      }
      if (typeof val === 'string' && val.indexOf(':') !== -1) {
        return parseInt(this.$dateUtil.getSecondByHm(val), 10)
      }
      return ''
    },
    syncPickerTime () {
      const sec = this.secondsFromPicker()
      this.trialLessonParam.time = sec === '' || Number.isNaN(sec) ? '' : sec
    },
    insertTrialLesson () {
      let self = this
      self.syncPickerTime()
      self.loadingConfirm = true
      self.$refs.trialLessonForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingConfirm = false
          return
        }
        self.trialLessonParam.lsnBeginTime = self.getLsnBeginTime()
        self.$http.post('/user/lesson/addCourse', self.trialLessonParam).then(function (res) {
          self.loadingConfirm = false
          if (res) {
            self.$Message.success('约课成功!')
            self.visible = false
          }
        })
      })
    },
    searchTch (courseType) {
      let self = this
      self.syncPickerTime()
      let isNotError = true
      self.$refs.trialLessonForm.validateField('lsnBeginDayTime', (valid) => {
        if (valid !== '') isNotError = false
      })
      if (!isNotError) return
      self.loadingSearch = true
      self.tchList = []
      let path = '/tch/time/queryFreeNotChineseTch?isAudition=y&lsnBeginTime=' + self.getLsnBeginTime() +
        '&timeLength=' + self.trialLessonParam.timeLength + '&tchType=1' + '&uid=' + self.trialLessonParam.uid
      if (self.tId) {
        path = path + '&tchId=' + self.tId
      }
      if (self.trialLessonParam.category) {
        path = path + '&category=' + self.trialLessonParam.category
      }
      if (self.trialLessonParam.suitableLevel) {
        path = path + '&suitableLevel=' + self.trialLessonParam.suitableLevel
      }
      if (self.trialLessonParam.channel) {
        path = path + '&channel=' + self.trialLessonParam.channel
      }
      if (self.trialLessonParam.accent) {
        path = path + '&accent=' + self.trialLessonParam.accent
      }
      if (self.trialLessonParam.sex) {
        path = path + '&sex=' + self.trialLessonParam.sex
      }
      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data
        }
        self.loadingSearch = false
      })
    },
    onChangeTime (val) {
      this.trialLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val))
      this.clearTchList()
    },
    lsnBeginTimeDateChange (value) {
      this.trialLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      this.clearTchList()
    },
    loadBookMaterialLevel () {
      let self = this
      if (self.bookMaterialLevelList) {
        return
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLevelList = res.data
      })
    },
    loadTimeLengthList (val) {
      let self = this
      self.$http.get('/user/lesson/timeLengthList?uid=' + val).then(function (res) {
        if (res && res.data) {
          self.timeLengthList = res.data
          // 如果返回的数据为空或者没有默认选中项，则保持原有逻辑
          if (self.timeLengthList && self.timeLengthList.length > 0) {
            // 设置默认选中第一个
            self.trialLessonParam.timeLength = self.timeLengthList[0].code
          }
        } else {
          // 接口调用失败时，保持原有的默认值逻辑
          if (self.user.tchChannel === 1) {
            self.timeLengthList = [{code: 25, text: '25'}]
            self.trialLessonParam.timeLength = 25
          } else {
            self.timeLengthList = [{code: 25, text: '25'}]
            self.trialLessonParam.timeLength = 25
          }
        }
      }).catch(function (error) {
        // 异常处理，使用默认值
        console.error('获取时长列表失败:', error)
        if (self.user.tchChannel === 1) {
          self.timeLengthList = [{code: 25, text: '25'}]
          self.trialLessonParam.timeLength = 25
        } else {
          self.timeLengthList = [{code: 25, text: '25'}]
          self.trialLessonParam.timeLength = 25
        }
      })
    },
    changeLevel (val) {
      if (!val) {
        return
      } else {
        let self = this
        self.bookMaterialLessonsList = null
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLessonsList = res.data
        })
      }
    },
    getLsnBeginTime () {
      return parseInt(this.trialLessonParam.lsnBeginDayTime) + parseInt(this.trialLessonParam.time)
    },
    clearTchList () {
      this.tchList = []
      this.trialLessonParam.tchId = ''
    },
    showTchMessage (id) {
      this.tchId = parseInt(id)
      this.showTchInfoModal = true
    },
    updateTchInfoSuccess () {
      this.showTchInfoModal = false
    },
    onTchChange (id, name) {
      this.tchName = name
      if (id) {
        this.searchTch()
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
        this.loadingConfirm = false
        this.loadBookMaterialLevel()
        this.loadTimeLengthList(this.user.id) // 从接口获取时长列表
        this.$refs['trialLessonForm'].resetFields()
        this.trialLessonParam.uid = this.user.id
        this.trialLessonParam.nickname = this.user.nickname
        this.trialLessonParam.mobile = this.user.mobile

        let now = new Date()
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        this.trialLessonParam.lsnBeginTimeDate = now
        this.trialLessonParam.lsnBeginDayTime = now.getTime() / 1000
        this.timeStr = '18:00'
        this.trialLessonParam.time = 18 * 3600
        this.timePickerKey += 1
        this.clearTchList()
      } else {
        this.tId = ''
        this.tchName = ''
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserTrialLessonModal.vue?2bc6941c